<mat-card class="mat-elevation-z8 main-container">
  @if (loading) {
    <div class="spinner-element">
      <mat-spinner [diameter]="24"></mat-spinner>
    </div>
  }

  @if (hasTitle) {
    <mat-card-title>
      <div class="subset-title">
        <div class="title-info">{{ config.title }}</div>
        @if (canEdit && config.updateUrl && mode !== 'add' && mode !== 'report') {
          <span>
            @if (!edit) {
              <button
                [attr.data-id]="'editConfig_' + config.title"
                mat-icon-button
                color="accent"
                (click)="startEditing()"
                matTooltip="Edit">
                <mat-icon>edit</mat-icon>
              </button>
            }
            @if (edit) {
              <button
                [attr.data-id]="'saveConfig_' + config.title"
                mat-mini-fab
                color="accent"
                (click)="doEdit()"
                matTooltip="Save changes">
                <mat-icon>save</mat-icon>
              </button>
            }
            @if (edit) {
              <button
                [attr.data-id]="'cancelEdit_' + config.title"
                mat-icon-button
                color="warn"
                (click)="stopEditing()"
                matTooltip="Cancel">
                <mat-icon>cancel</mat-icon>
              </button>
            }
          </span>
        }
      </div>
      <mat-divider></mat-divider>
    </mat-card-title>
  }

  <mat-card-content class="table-container">
    <div [ngClass]="{ 'flex-mode': rows?.length > 1 }">
      <table class="main-table">
        @for (row of rows; track row) {
          <tr>
            @for (field of row; track field) {
              <td [style]="transform(field.tableCss)">
                @if (field && !isIgnored(field, getDataForFormField(field))) {
                  <div class="actions-container" [ngClass]="{ disabled: field.editReadOnly && edit }">
                    @if (!field.formFullWidth && !field.noLabel) {
                      <div class="action-buttons">
                        @if (field.help) {
                          <button mat-icon-button color="primary" [matTooltip]="field.help">
                            <mat-icon class="info-icon">help</mat-icon>
                          </button>
                        }
                        {{ field.label }}
                      </div>
                    }
                    <div class="edit-container">
                      <app-form-field
                        [type]="field.type"
                        [data]="getDataForFormField(field)"
                        [fieldConfig]="field"
                        [(editMode)]="edit"
                        [attr.data-id]="'fieldLabel_' + field.label"
                        [formGroup]="getFormConfig()"
                        [rowData]="data"></app-form-field>
                    </div>
                  </div>
                }
              </td>
            }
          </tr>
        }
      </table>
    </div>
  </mat-card-content>
  @if (config.actions && config.actions.length > 0 && !edit) {
    <mat-card-actions class="bottom-actions">
      @for (action of config.actions; track action) {
        <app-action [actionConfig]="action" [data]="nestedData" (onResponse)="loadingEmitter.emit(false)"></app-action>
      }
    </mat-card-actions>
  }
</mat-card>
